interface PdfPreviewProps {
  isPdf: boolean;
  isImage?: boolean;
  dataUrl: string | null;
  directFileUrl: string | null;
  fileError: string | null;
  fileName: string;
  onOpenInNewTab: () => void;
}

const PdfPreview: React.FC<PdfPreviewProps> = ({
  isPdf,
  isImage,
  dataUrl,
  directFileUrl,
  fileError,
  fileName,
  onOpenInNewTab,
}) => {
  // Image preview
  if (isImage && (dataUrl || directFileUrl)) {
    const src = dataUrl || directFileUrl!;
    return (
      <div className="pdf-preview">
        <img
          src={src}
          alt={fileName}
          className="image-preview"
          style={{ maxWidth: '100%', maxHeight: '600px', objectFit: 'contain', borderRadius: '4px', border: '1px solid #ddd' }}
        />
        <div className="pdf-actions-container">
          <button onClick={onOpenInNewTab} className="pdf-action-button">
            Voir dans un nouvel onglet
          </button>
        </div>
      </div>
    );
  }

  if (isImage && fileError) {
    return (
      <div className="file-error-message">
        <p>Impossible de charger l'image: {fileError}</p>
        <p>Le fichier a peut-être été déplacé ou supprimé.</p>
      </div>
    );
  }

  if (isImage) {
    return <div className="loading">Chargement de l'aperçu...</div>;
  }

  // PDF preview
  if (isPdf && dataUrl) {
    return (
      <div className="pdf-preview">
        <iframe
          src={dataUrl}
          className="pdf-iframe"
          width="100%"
          height="600px"
          frameBorder="0"
          title="Aperçu PDF"
        />
        <div className="pdf-actions-container">
          <button onClick={onOpenInNewTab} className="pdf-action-button">
            Voir le PDF dans un nouvel onglet
          </button>
        </div>
      </div>
    );
  }

  if (isPdf && directFileUrl) {
    return (
      <div className="pdf-preview">
        <div className="pdf-fallback">
          <p>L'aperçu du PDF est disponible mais ne peut pas être affiché en ligne.</p>
          <div className="pdf-actions-container">
            <button onClick={onOpenInNewTab} className="pdf-action-button">
              Voir le PDF dans un nouvel onglet
            </button>
          </div>
        </div>
      </div>
    );
  }

  if (isPdf && fileError) {
    return (
      <div className="file-error-message">
        <p>Impossible de charger le fichier PDF: {fileError}</p>
        <p>Le fichier a peut-être été déplacé ou supprimé.</p>
      </div>
    );
  }

  if (isPdf) {
    return <div className="loading">Chargement de l'aperçu PDF...</div>;
  }

  return (
    <div className="non-pdf-message">
      <p>Ce fichier ne peut pas être prévisualisé.</p>
      <p>Nom du fichier: {fileName}</p>
    </div>
  );
};

export default PdfPreview;
